module.exports = __webpack_public_path__ + "img/money.827cd44b.png";